import { FAVOURITE_SAVE_CONFIRMATION } from "./favourite-button-state";
import {
  isSupProfileKey,
  type SupProfileKey,
} from "@/lib/conditions/sport-profiles";

export type CompanionConditionSpotType = "ski" | "surf" | "sailing";
export type SaveToCompanionKind = "condition" | "festival";

const SKI_CATEGORIES = new Set(["ski", "piste", "offpiste", "off-piste", "touring", "mtb"]);

export function companionSpotTypeForCategory(
  category: string | null | undefined,
): CompanionConditionSpotType {
  const key = category?.toLowerCase().trim();
  if (key === "sailing") return "sailing";
  if (key && SKI_CATEGORIES.has(key)) return "ski";
  return "surf";
}

export function saveToCompanionConfirmation(kind: SaveToCompanionKind): string {
  if (kind === "festival") {
    return "Saved to Companion. PeakWave will keep this festival window handy.";
  }
  return FAVOURITE_SAVE_CONFIRMATION;
}

export function conditionSaveSignupSport(
  spotType: CompanionConditionSpotType | undefined,
  allowedSupProfiles: readonly string[] | undefined,
): CompanionConditionSpotType | SupProfileKey | undefined {
  if (
    allowedSupProfiles?.length === 1 &&
    isSupProfileKey(allowedSupProfiles[0] ?? "")
  ) {
    return allowedSupProfiles[0] as SupProfileKey;
  }
  return spotType;
}
